import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1043.000000 1080.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >
				path d="M4780 9850 c-766 -35 -1534 -290 -2180 -723 -455 -306 -883 -737
-1181 -1192 -380 -580 -604 -1207 -686 -1920 -25 -218 -25 -1091 0 -1310 91
-803 367 -1506 835 -2130 235 -313 532 -612 840 -844 242 -182 414 -287 707
-431 487 -240 989 -378 1525 -420 364 -28 983 -21 1300 16 336 39 775 152
1087 280 99 40 433 204 533 260 132 74 451 292 526 359 7 5 31 26 55 45 177
142 432 397 579 580 25 30 47 57 50 60 21 21 143 189 217 300 377 566 610
1213 690 1920 26 227 26 1094 0 1320 -81 713 -310 1351 -690 1920 -73 110
-194 277 -217 300 -3 3 -23 28 -44 55 -130 164 -412 447 -585 585 -24 19 -48
40 -55 45 -6 6 -40 32 -76 58 -36 27 -73 54 -82 62 -38 31 -258 174 -333 217
-374 212 -624 319 -1005 432 -265 78 -640 140 -940 155 -196 10 -668 10 -870
1z m864 -245 c145 -15 302 -40 463 -75 108 -23 349 -87 378 -100 11 -4 65 -23
120 -40 55 -18 114 -38 130 -45 17 -7 75 -32 130 -55 109 -46 341 -160 420
-207 28 -16 58 -32 67 -36 9 -3 52 -29 94 -57 42 -28 89 -57 104 -65 15 -8 59
-38 97 -67 39 -29 81 -60 93 -68 216 -146 611 -526 795 -765 22 -29 68 -89
103 -133 72 -94 213 -312 294 -457 67 -120 182 -357 204 -421 8 -25 28 -73 44
-107 15 -34 50 -132 78 -217 69 -212 110 -382 151 -620 7 -36 16 -90 21 -120
20 -113 40 -401 40 -575 0 -383 -43 -719 -140 -1097 -35 -137 -115 -391 -140
-443 -25 -52 -60 -138 -60 -146 0 -15 -129 -278 -193 -394 -68 -123 -223 -369
-271 -430 -17 -22 -34 -44 -39 -50 -4 -5 -37 -48 -73 -95 -157 -201 -348 -402
-559 -586 -111 -97 -130 -112 -250 -201 -6 -5 -33 -24 -60 -42 -28 -19 -52
-38 -55 -42 -6 -8 -155 -104 -235 -151 -173 -103 -419 -225 -590 -293 -38 -15
-83 -33 -100 -40 -16 -7 -68 -25 -115 -40 -47 -14 -94 -30 -105 -35 -69 -30
-392 -108 -560 -136 -49 -8 -110 -18 -135 -23 -25 -5 -168 -17 -317 -27 -258
-16 -287 -16 -534 0 -144 9 -282 21 -308 26 -25 4 -82 14 -126 21 -316 48
-729 173 -1045 316 -168 76 -468 238 -537 289 -17 13 -34 24 -37 24 -8 0 -211
144 -214 152 -2 5 -10 8 -18 8 -8 0 -14 3 -14 8 0 4 -17 18 -38 32 -40 27 -40
27 -223 187 -251 222 -499 500 -675 758 -64 93 -149 225 -177 275 -171 299
-271 521 -372 825 -37 112 -56 178 -105 365 -13 50 -66 349 -79 450 -42 321
-42 697 0 1035 12 100 64 401 79 455 5 19 21 80 36 135 110 414 296 835 522
1185 90 140 156 235 164 238 4 2 8 10 8 17 0 7 4 15 8 17 4 2 35 37 67 78 56
70 165 201 189 226 107 113 221 225 292 289 49 44 91 82 94 85 3 3 30 25 60
50 30 24 62 50 70 57 56 47 92 75 145 110 33 22 96 64 140 94 203 138 492 293
725 388 58 24 114 47 125 52 47 20 258 89 360 117 310 86 647 141 960 156 125
6 484 -5 629 -19z"/>
<path d="M4940 9023 c-30 -2 -109 -11 -175 -19 -66 -9 -147 -20 -180 -24 -201
-27 -564 -134 -792 -234 -45 -20 -84 -36 -88 -36 -26 0 -345 -173 -453 -247
-35 -24 -66 -43 -69 -43 -6 0 -185 -131 -255 -188 -125 -101 -159 -129 -228
-197 -125 -121 -232 -236 -303 -325 -38 -47 -74 -93 -82 -102 -24 -29 -172
-235 -176 -244 -2 -5 -20 -35 -39 -67 -19 -32 -47 -80 -63 -105 -15 -26 -54
-99 -86 -162 -361 -708 -481 -1540 -335 -2320 35 -188 124 -508 170 -615 7
-16 30 -73 50 -125 50 -125 198 -416 271 -531 70 -110 273 -383 340 -458 120
-135 205 -222 295 -302 14 -13 56 -50 92 -83 113 -101 244 -196 501 -361 34
-22 33 -22 165 -92 52 -28 106 -54 120 -58 14 -4 27 -11 30 -14 7 -9 230 -103
330 -139 216 -78 447 -137 660 -168 450 -66 931 -54 1322 32 40 9 91 20 113
24 22 4 81 20 130 35 50 14 110 32 135 39 55 16 196 70 270 103 30 14 75 33
100 43 59 24 320 158 390 201 166 103 402 275 505 369 138 126 181 168 255
246 125 131 151 163 280 334 371 493 598 1046 695 1695 40 269 38 759 -5 1015
-5 30 -14 87 -21 125 -31 190 -136 558 -204 711 -14 31 -25 61 -25 66 0 14
-174 361 -212 426 -18 28 -36 52 -40 52 -4 0 -8 6 -8 13 0 19 -116 191 -222
329 -127 166 -362 411 -512 533 -26 22 -56 47 -65 56 -43 41 -166 133 -261
194 -58 37 -123 80 -145 95 -37 24 -110 66 -240 135 -115 61 -392 175 -535
220 -399 126 -736 177 -1150 173 -107 -1 -220 -3 -250 -5z m655 -178 c77 -8
177 -22 223 -30 101 -18 413 -94 427 -104 5 -4 60 -22 120 -41 61 -19 112 -37
115 -41 3 -3 25 -13 50 -23 171 -66 426 -197 533 -272 26 -19 50 -34 53 -34 6
0 96 -61 104 -71 3 -3 19 -13 35 -22 17 -9 41 -26 56 -39 14 -13 32 -27 41
-33 42 -26 252 -212 324 -286 111 -116 261 -286 290 -328 13 -20 44 -63 69
-96 38 -51 136 -199 178 -270 7 -10 23 -37 36 -60 30 -49 119 -227 156 -310
198 -448 303 -956 299 -1440 -6 -583 -167 -1180 -454 -1683 -93 -161 -99 -171
-162 -264 -158 -228 -374 -472 -568 -639 -41 -35 -81 -71 -90 -78 -59 -56
-390 -285 -490 -340 -179 -96 -341 -172 -476 -222 -32 -12 -63 -25 -69 -29 -5
-4 -26 -12 -45 -18 -19 -5 -89 -25 -155 -45 -66 -19 -131 -37 -145 -40 -305
-64 -328 -68 -575 -90 -232 -21 -631 -5 -815 33 -25 5 -76 14 -115 21 -84 14
-314 71 -405 100 -241 77 -527 211 -775 362 -44 27 -110 71 -115 77 -3 3 -32
23 -64 45 -203 132 -521 432 -696 656 -411 524 -652 1087 -740 1729 -26 185
-36 531 -21 708 28 344 110 706 232 1023 61 161 193 420 302 593 176 282 458
603 707 807 36 29 67 55 70 59 6 6 128 99 156 118 241 164 571 342 713 384 19
5 44 16 55 23 12 7 59 25 106 40 47 14 94 30 105 35 21 10 207 59 290 78 145
32 417 68 585 76 125 6 397 -4 545 -19z"/>
<path d="M6133 7559 c-139 -18 -299 -93 -395 -184 -21 -20 -39 -44 -39 -53 -4
-54 15 -82 56 -82 12 0 51 23 86 50 35 28 69 54 74 58 6 4 37 19 70 34 193 85
430 59 594 -64 31 -23 62 -50 69 -60 30 -42 112 -7 112 48 0 49 -157 169 -281
214 -101 37 -238 52 -346 39z"/>
<path d="M6160 7364 c-125 -22 -227 -72 -305 -150 -40 -39 -46 -81 -17 -107
32 -29 70 -21 121 26 64 56 127 87 208 98 120 17 230 -17 325 -100 50 -45 94
-54 122 -25 22 21 20 66 -4 97 -31 39 -147 112 -216 135 -60 21 -185 35 -234
26z"/>
<path d="M6140 7161 c-98 -30 -190 -110 -190 -166 0 -36 11 -49 53 -59 22 -5
34 0 70 34 102 93 203 94 299 2 54 -52 109 -47 131 12 17 45 -87 144 -181 172
-48 15 -141 17 -182 5z"/>
<path d="M6163 6955 c-71 -31 -86 -152 -24 -207 26 -23 40 -28 86 -28 46 0 60
5 86 28 27 24 33 37 37 84 3 42 0 62 -13 82 -35 53 -106 70 -172 41z"/>
<path d="M5283 4122 c-80 -3 -83 -4 -83 -27 0 -29 12 -37 59 -39 l36 -1 0 -70
c0 -68 -1 -70 -25 -69 -14 1 -34 5 -45 8 -15 5 -24 0 -36 -20 l-16 -26 -41 60
-40 59 44 51 c24 28 44 55 44 61 0 6 -19 11 -43 11 -38 0 -47 -5 -80 -45 -21
-25 -42 -45 -48 -45 -5 0 -8 19 -7 43 l3 42 -40 0 -40 0 -3 -120 c-4 -156 -1
-165 43 -165 19 0 36 3 36 8 1 4 3 16 4 27 4 33 16 65 25 65 5 0 18 -16 30
-35 12 -19 31 -42 43 -50 27 -19 76 -19 83 0 5 13 9 13 34 0 47 -24 94 -19
129 14 l31 29 0 115 c0 64 -3 117 -7 119 -5 2 -45 2 -90 0z"/>
<path d="M5656 4118 c-9 -5 -31 -38 -48 -74 -17 -35 -34 -64 -37 -64 -3 1 -21
32 -39 70 l-34 70 -44 0 -45 0 3 -142 3 -143 32 -3 32 -3 3 73 c2 54 6 68 12
53 28 -61 57 -95 81 -95 20 0 30 11 54 58 l30 57 1 -67 c0 -64 1 -68 25 -74
49 -12 56 6 53 150 l-3 130 -31 7 c-18 3 -39 2 -48 -3z"/>
<path d="M6182 4120 c-29 -4 -36 -12 -54 -55 -12 -27 -36 -85 -55 -128 -19
-43 -32 -85 -29 -93 3 -8 19 -14 35 -14 24 0 34 7 46 30 14 27 20 30 65 30 43
0 51 -4 70 -30 23 -33 73 -42 83 -16 7 17 -102 274 -117 279 -6 1 -26 1 -44
-3z m21 -158 c-24 -6 -31 3 -21 28 l9 24 12 -24 c11 -20 10 -26 0 -28z"/>
<path d="M6420 4120 c-92 -4 -115 -8 -117 -20 -5 -26 14 -43 48 -44 l34 -1 5
-110 5 -110 35 0 35 0 3 107 c3 117 -1 110 67 120 23 4 32 40 13 54 -7 5 -65
7 -128 4z"/>
<path d="M6880 4119 c-34 -14 -60 -48 -60 -80 0 -41 35 -76 96 -96 30 -9 53
-22 51 -27 -6 -19 -45 -18 -89 4 -40 19 -44 19 -55 3 -7 -9 -13 -24 -13 -32 0
-9 -13 13 -29 49 -15 36 -37 86 -49 112 -12 26 -22 52 -22 58 0 7 -17 10 -46
8 l-46 -3 -58 -132 c-59 -135 -61 -153 -15 -153 26 0 39 10 54 38 10 19 20 22
65 22 51 0 55 -2 65 -30 8 -24 16 -30 40 -30 16 0 36 6 43 14 12 12 19 12 47
0 41 -17 108 -18 140 -1 14 6 33 27 44 44 16 28 17 36 5 59 -14 29 -55 64 -79
68 -63 11 -84 43 -21 33 20 -3 47 -9 58 -12 17 -5 23 -1 32 24 10 28 8 33 -12
46 -30 20 -114 28 -146 14z m-206 -125 c10 -26 7 -34 -14 -34 -11 0 -20 4 -20
9 0 17 12 41 20 41 4 0 11 -7 14 -16z"/>
<path d="M7082 4122 c-18 -6 -16 -183 2 -227 26 -62 126 -86 193 -45 45 27 52
46 57 159 4 88 2 102 -12 109 -9 4 -24 7 -32 6 -8 -1 -21 -2 -27 -3 -10 -1
-13 -27 -13 -94 0 -101 -7 -117 -52 -117 -38 0 -48 25 -48 124 0 47 -3 86 -7
87 -5 0 -17 2 -28 3 -12 1 -26 1 -33 -2z"/>
<path d="M5780 4113 c-1 -13 -2 -257 -1 -272 1 -11 18 -13 84 -9 139 7 187 46
187 152 0 48 -4 60 -27 85 -16 15 -38 33 -50 40 -24 12 -193 16 -193 4z m168
-88 c43 -50 18 -109 -50 -119 -31 -5 -38 -2 -43 14 -6 20 -5 119 2 132 8 15
69 -3 91 -27z"/>
<path d="M7360 3988 c0 -73 4 -139 9 -147 13 -20 170 -11 205 13 42 27 54 62
34 97 -12 21 -15 42 -11 82 8 76 -9 87 -139 87 l-98 0 0 -132z m158 50 c3 -15
-4 -18 -36 -18 -40 0 -42 2 -33 38 1 2 16 2 33 0 22 -2 34 -9 36 -20z m10
-115 c-2 -14 -13 -18 -43 -18 -30 0 -41 4 -43 18 -3 14 4 17 43 17 39 0 46 -3
43 -17z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
